import React, { useState, useRef } from "react";
import { Grid, IconButton, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridActionsCellItem, gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDateRangePicker } from "@mui/x-date-pickers-pro";
import * as dayjs from "dayjs";
import Filter from "../../../Filter";
import { DataGridPro } from "@mui/x-data-grid-pro";

const NoHeaderDataGrid = styled(DataGridPro)(({ }) => ({ "& .MuiDataGrid-columnHeaders": { display: "none" }, "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" } }));

const WeeksTab = ({ currentCenterID, centerWeeks, setCenterWeeks, admin }) => {


    console.log(admin)


    var weekOfYear = require("dayjs/plugin/weekOfYear");
    dayjs.extend(weekOfYear);

    var customParseFormat = require("dayjs/plugin/customParseFormat");
    dayjs.extend(customParseFormat);

    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];
    const [currentRange, setCurrentRange] = useState([new Date(`${new Date().getFullYear()}-07-01`), null]);

    const weekToName = (week) => {
        return `Week ${week.weekNumber} of ${monthNames[parseInt(week.startDate.slice(-5)) - 1]}`;
    };

    const weekToRange = (week) => {
        return `(${dayjs(week.startDate).format('DD/MM/YYYY')} - ${dayjs(week.endDate).format('DD/MM/YYYY')})`;
    };

    const [filter, setFilter] = useState("");
    const [activeFilter, setActiveFilter] = useState(true);

    const searchBarHelper = "Search for a week...";

    const updateActiveFilter = (e) => {
        setActiveFilter(e.target.checked);
    }

    const HandleFilter = (e) => {
        setFilter(e.toLowerCase());
    };

    function filterWeek(week) {
        return weekToName(week).toLowerCase().includes(filter) || dayjs(week.startDate).year().toString().includes(filter)
    }

    const addWeek = () => {
        if (!currentRange[0] || !currentRange[1]) return;
        setCenterWeeks([
            ...centerWeeks,
            {
                id: -Math.random(),
                weekNumber: centerWeeks.length + 1,
                startDate: currentRange[0].format("YYYY-MM-DD"),
                endDate: currentRange[1].format("YYYY-MM-DD"),
                idCenter: currentCenterID,
            },
        ]);
        setCurrentRange([null, null]);
    };

    const deleteWeek = (params) => {
        setCenterWeeks(centerWeeks.filter(function (center) {
            return center.id !== params.id
        }));
    };

    const getTreeDataPath = (week) => {
        return [dayjs(week.startDate).year(), week.name]
    };

    const centerWeeksCols = [
        { field: 'range', align: 'right', headerName: '', width: '200' },
        {
            field: 'actions',
            type: 'actions',
            sortable: false,
            getActions: (params) => {
                return [
                    <>
                        {admin &&
                            <GridActionsCellItem icon={params.row.id ? <DeleteIcon /> : <></>} onClick={() => deleteWeek(params)} />
                        }
                    </>
                ]
            }
        }
    ]

    const NoHeaderDataGrid = styled(DataGrid)(({ }) => ({ "& .MuiDataGrid-columnHeaders": { display: "none" }, "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" } }));
    return (
        <Grid item xs={12} container sx={{ height: 350 }}>
            <div className="container">
                <div className="justify-content-end d-flex p-3 m-6">
                    <Filter
                        setSearchQuery={HandleFilter}
                        searchQuery={filter}
                        HideAddButton={!admin || (!currentRange[0] || !currentRange[1])}
                        helper={searchBarHelper}
                        addDataFunction={addWeek}
                        setActive={updateActiveFilter}
                    />
                </div>
            </div>
            <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <StaticDateRangePicker
                        calendars={1}
                        displayStaticWrapperAs="desktop"
                        value={currentRange}
                        onChange={(newValue) => {
                            setCurrentRange(newValue);
                        }}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={8} container sx={{ height: 300 }}>
                <div style={{ height: 300, width: '100%' }}>
                    <DataGridPro
                        treeData
                        defaultGroupingExpansionDepth={0}
                        rowGroupingColumnMode="single"

                        getTreeDataPath={getTreeDataPath}
                        groupingColDef={{ headerName: 'Available Weeks', flex: 1, renderHeader: 0 }}
                        rows={
                            centerWeeks.filter(filterWeek).map((week) => {
                                week.key = Math.random();
                                week.startDate = dayjs(week.startDate).format("YYYY-MM-DD");
                                week.endDate = dayjs(week.endDate).format("YYYY-MM-DD");
                                week.name = weekToName(week);
                                week.range = weekToRange(week);
                                return week;
                            })}
                        hideFooter
                        columns={centerWeeksCols}
                        disableSelectionOnClick
                        rowsPerPageOptions={[]} />
                </div>
            </Grid>
        </Grid>
    )

}

export default WeeksTab;